//import auth0 from 'auth0-js'
import EventEmitter from 'events'
//import authConfig from '@/../auth_config.json'

//import store from '@/store/store.js'

// 'loggedIn' is used in other parts of application. So, Don't forget to change there also
const localStorageKey = 'loggedIn'

const tokenExpiryKey = 'tokenExpiry'
//const loginEvent = 'loginEvent'


class AuthService extends EventEmitter {
    idToken = null;
    profile = null;
    tokenExpiry = null;


    logOut () {
      localStorage.removeItem(localStorageKey)
      localStorage.removeItem(tokenExpiryKey)
      localStorage.removeItem('userInfo')
      localStorage.removeItem('loggedIn')
      localStorage.removeItem('cell')
      localStorage.removeItem('accessToken')
      localStorage.removeItem('permissions')
      localStorage.removeItem('pua')
    }

    isAuthenticated () {
      if (new Date(Date.now()) < new Date(parseInt(localStorage.getItem(tokenExpiryKey))) &&
      localStorage.getItem(localStorageKey) === 'true') {
        return true
      }
      return false
    }
}

export default new AuthService()
